<template>
  <PriceStructView :quote-obj='rows' :platform-type='platformType'></PriceStructView>
</template>
<script>

import PriceStructView from './PriceStructView'

export default {
  name: 'PlcPriceGrids',
  components: { PriceStructView },
  props: {
    rows: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    platformType: {
      type: String,
      default() {
        return 'ONLINE'
      }
    },
  }
}
</script>

<style scoped>
.price-panel {
  width: 100%;
  /*border: #fe346e 1px dashed;*/
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: flex-start;

}
</style>
